var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15SForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.354,
    height: 20.815,
    viewBox: "0 0 23.354 20.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_15s-forward",
    "data-name": "15s-forward",
    transform: "translate(-296.646 -684)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_15s",
    "data-name": "15s",
    transform: "translate(306 698)",
    fill: "#dbb200",
    fontSize: 8,
    fontFamily: "Heebo-Medium, Heebo",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15s")), /*#__PURE__*/React.createElement("g", {
    id: "reload-icon",
    transform: "translate(296.646 704.815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_381",
    "data-name": "Grupo 381",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_380",
    "data-name": "Grupo 380",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_728",
    "data-name": "Caminho 728",
    d: "M18.27,10.178a.509.509,0,0,1-.509-.509A8.646,8.646,0,0,0,.988,6.716a.509.509,0,1,1-.957-.348,9.664,9.664,0,0,1,18.748,3.3A.509.509,0,0,1,18.27,10.178Z",
    fill: "#dbb200"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_387",
    "data-name": "Grupo 387",
    transform: "translate(15.727 8.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_386",
    "data-name": "Grupo 386",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M4.94.869,2.9,2.9a.509.509,0,0,1-.72,0L.149.869A.509.509,0,0,1,.868.15L2.544,1.825,4.219.149A.51.51,0,0,1,4.94.869Z",
    fill: "#dbb200"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15SForward);
export default __webpack_public_path__ + "static/media/15s-forward.ae1302e9b1878fa708fc3f88ce05f827.svg";
export { ForwardRef as ReactComponent };